import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "float-left bg-black shadow rounded overflow-hidden relative" }
const _hoisted_2 = { class: "" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("a", { class: "frame z-1 bg-clip-padding bg-frame-gradient bg-no-repeat bg-frame rounded-lg shadow-frame box-border block h-full left-0 overflow-hidden absolute right-0 top-0 whitespace-nowrap" }, null, -1)
const _hoisted_5 = { class: "anime-details ml-24 w-auto float-none" }
const _hoisted_6 = { class: "font-garamond font-normal text-2xl text-white leading-5 h-auto" }
const _hoisted_7 = { class: "mr-1" }
const _hoisted_8 = { class: "anime-title text-2xl mb-1 text-white font-garamond font-extrabold leading-none" }
const _hoisted_9 = { class: "mr-2 font-quicksand text-base text-gray-text" }
const _hoisted_10 = { class: "-mt-4 overflow-hidden text-base leading-6 font-garamond font-semibold" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "release-year text-sm leading-5 mt-1.5 mb-1 uppercase tracking-wider" }, "Studio", -1)
const _hoisted_12 = { class: "anime-studio text-base leading-5 mb-1 font-black capitalize" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("img", {
          class: "result-image rounded block w-80px",
          src: _ctx.anime.node.main_picture.medium,
          alt: _ctx.anime.node.title
        }, null, 8, _hoisted_3),
        _hoisted_4
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("h2", _hoisted_6, [
        _createElementVNode("span", _hoisted_7, [
          _createVNode(_component_router_link, {
            to: '/anime/' + _ctx.anime.node.id + '/' + _ctx.anime.node.title
          }, {
            default: _withCtx(() => [
              _createElementVNode("h1", _hoisted_8, _toDisplayString(_ctx.anime.node.title), 1)
            ]),
            _: 1
          }, 8, ["to"]),
          _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.anime.node.start_season.year), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        (_ctx.anime.node.synopsis.length > 200)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(`short-synopsis${_ctx.anime.node.id} block flex`)
            }, [
              _createElementVNode("p", null, [
                _createTextVNode(_toDisplayString(_ctx.anime.node.synopsis.substring(0, 200)) + " ", 1),
                _createElementVNode("button", {
                  class: "font-black text-gray-text2",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleSynopsis && _ctx.toggleSynopsis(...args)))
                }, "...more")
              ])
            ], 2))
          : _createCommentVNode("", true),
        (_ctx.anime.node.synopsis.length > 200)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: _normalizeClass(`full-synopsis${_ctx.anime.node.id} block hidden`)
            }, [
              _createElementVNode("p", null, [
                _createTextVNode(_toDisplayString(_ctx.anime.node.synopsis) + " ", 1),
                _createElementVNode("button", {
                  class: "font-black text-gray-text2",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleSynopsis && _ctx.toggleSynopsis(...args)))
                }, "...less")
              ])
            ], 2))
          : _createCommentVNode("", true),
        (_ctx.anime.node.synopsis.length < 200)
          ? (_openBlock(), _createElementBlock("div", {
              key: 2,
              class: _normalizeClass(`full-synopsis${_ctx.anime.node.id} block`)
            }, [
              _createElementVNode("p", null, _toDisplayString(_ctx.anime.node.synopsis), 1)
            ], 2))
          : _createCommentVNode("", true)
      ]),
      _hoisted_11,
      _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.anime.node.studios[0].name || 'thn'), 1)
    ])
  ], 64))
}